<app-hero-section></app-hero-section>

<app-products-section></app-products-section>

<app-inspire-section></app-inspire-section>

<app-process-section></app-process-section>

<app-style-section></app-style-section>

<app-testimonials-section></app-testimonials-section>

<app-faq-section></app-faq-section>

<app-create-section></app-create-section>
